module.exports = __webpack_public_path__ + "static/img/20230428_01.bbbd9b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2023/20230428_01.png
// module id = qndO
// module chunks = 0